import { create } from 'zustand';
import apiClient from '../service/apiClient';
import { Page, ResponseError } from '../type/type';
import { toast } from 'react-toastify';
import { isAxiosError } from 'axios';

export interface IFortuneLabUserItem {
  id: number;
  name: string;
  phoneNumber: string;
  birthDate: string;
  solarType?: string;
  birthDayJu: string;
  trkId: string;
  campaignName?: string;
  companyName?: string;
  createdAt: string;
  updatedAt: string;
}

interface FortuneLabUserResponse extends Page {
  content: IFortuneLabUserItem[];
}

type FortuneLabPerformanceState = {
  resultList: IFortuneLabUserItem[];
  resultPage: Page | null;
};

type FortuneLabPerformanceAction = {
  fetchResults: (
    trkId?: string,
    name?: string,
    phoneNumber?: string,
    startDateTime?: string,
    endDateTime?: string,
    page?: number,
    size?: number
  ) => Promise<void>;
  deleteUser: (id: number) => Promise<boolean>;
};

export const useFortuneLabPerformanceStore = create<
  FortuneLabPerformanceState & FortuneLabPerformanceAction
>(set => ({
  resultList: [],
  resultPage: null,

  fetchResults: async (
    trkId,
    name,
    phoneNumber,
    startDateTime,
    endDateTime,
    page = 0,
    size = 20
  ) => {
    try {
      const response = await apiClient.get<FortuneLabUserResponse>(
        '/fortune-lab/users',
        {
          params: {
            trkId,
            name,
            phoneNumber,
            startDateTime,
            endDateTime,
            page,
            size,
            sort: 'createdAt,desc',
          },
        }
      );
      const { content, ...rest } = response.data;
      set({ resultList: content, resultPage: rest });
    } catch (error) {
      console.error(error);
      toast.error('실적 데이터를 조회하지 못했습니다.');
    }
  },

  deleteUser: async (id: number) => {
    try {
      await apiClient.delete(`/fortune-lab/users/${id}`);
      toast.success('신청 내역이 삭제되었습니다.');
      return true;
    } catch (error) {
      if (isAxiosError<ResponseError>(error)) {
        toast.error(error.response?.data.errorMsg ?? '삭제에 실패했습니다.');
      } else {
        console.error(error);
        toast.error('삭제에 실패했습니다.');
      }
      return false;
    }
  },
}));
